import errorMessage from 'Store/actions/errorMessage';
import { dateToJavaTimeConverter } from 'Utils/dateConverters';
import { loadStateFromIndexedDB } from 'Utils/manageIndexedDB';
import axios from 'axios';

import pickBy from 'lodash/pickBy';
import isArray from 'lodash/isArray';

import {
  GET_LIVE_SCORES_HEADER_REQUEST,
  GET_LIVE_SCORES_HEADER_SUCCESS,
  GET_LIVE_SCORES_HEADER_FAILURE,
  GET_LIVE_SCORES_EVENTS_REQUEST,
  GET_LIVE_SCORES_EVENTS_SUCCESS,
  GET_LIVE_SCORES_EVENTS_FAILURE,
  GET_LIVE_SCORES_EVENTS_UPDATE_FILTER,
  SUBSCRIBE_EVENT_SUCCESS,
  SUBSCRIBE_EVENT_FAILURE,
  SET_LIVE_SCORES_FILTER_REQUEST_OBJECT,
  GET_LIVE_SCORES_CLEAR_ALL_FILTER,
  GET_LIVE_SCORES_CLEAR_FILTER,
  SET_LIVE_SCORES_FILTERS_FROM_LOCAL_STORAGE,
  LIVE_SCORES_ACTIVE_TYPE
} from 'Store/constants';
import ProjectConfig from 'ProjectConfig';

const API_GATEWAY = ProjectConfig.API_GATEWAY;

export const getLiveScoresHeaders = () => async dispatch => {
  try {
    dispatch({
      type: GET_LIVE_SCORES_HEADER_REQUEST
    });

    const res = await axios.get(API_GATEWAY + '/mobile/live-score/header');

    dispatch({
      type: GET_LIVE_SCORES_HEADER_SUCCESS,
      payload: res.data
    });

  } catch (e) {
    dispatch({
      type: GET_LIVE_SCORES_HEADER_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const getLiveScoresEvents = (options = {}) => async dispatch => {
  const { eventType, filters } = options;
  let url;


  if (eventType === 'coupon') {
    url = `${API_GATEWAY}/mobile/live-score/user/${eventType}/event`;
  } else {
    url = `${API_GATEWAY}/mobile/live-score/event/v2/${eventType}`;
  }

  url += `?date=${dateToJavaTimeConverter(filters?.date)}`;

  try {
    dispatch({
      type: GET_LIVE_SCORES_EVENTS_REQUEST
    });
    const res = await axios.get( url );

    const payloadData = {
      competitions: eventType === 'coupon' ? res.data.mobileLiveScoreCouponEvents : res.data.competitions,
      basketballEvents: eventType === 'basketball' && res.data.competitions,
      soccerEvents: eventType === 'soccer' && res.data.competitions,
      mobileLiveScoreCouponEvents: res.data.mobileLiveScoreCouponEvents,
      filters: [filters],
      eventType: [eventType]
    };

    dispatch({
      type: GET_LIVE_SCORES_EVENTS_SUCCESS,
      payload: pickBy(payloadData, isArray)
    });

  } catch (e) {
    dispatch({
      type: GET_LIVE_SCORES_EVENTS_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const postEventSubscribe = (options = {}) => async dispatch => {
  const { eventId, matchDate, sportType } = options;

  const requestBody = {
    eventDate: matchDate
  };

  try {
    await axios.post(`${API_GATEWAY}/mobile/live-score/user/event/${eventId}/subscribe`, requestBody);

    dispatch({
      type: SUBSCRIBE_EVENT_SUCCESS,
      payload: { eventId, sportType }
    });

  } catch (e) {
    dispatch({
      type: SUBSCRIBE_EVENT_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const setLiveScoresFilterObject = (eventType, filterObject) => (dispatch, getState) => {
  dispatch({
    type: SET_LIVE_SCORES_FILTER_REQUEST_OBJECT,
    payload: { eventType, filterObject }
  });

  const soccerEvents = getState().liveScores.liveScoresEvents.soccerEvents;
  const basketballEvents = getState().liveScores.liveScoresEvents.basketballEvents;
  const competitions = getState().liveScores.liveScoresEvents.competitions;
  const mobileLiveScoreCouponEvents = getState().liveScores.liveScoresEvents.mobileLiveScoreCouponEvents;

  const payloadData = {
    competitions: competitions,
    basketballEvents: eventType === 'basketball' && basketballEvents,
    soccerEvents: eventType === 'soccer' && soccerEvents,
    mobileLiveScoreCouponEvents: mobileLiveScoreCouponEvents,
    filters: [filterObject],
    eventType: [eventType]
  };

  dispatch({
    type: GET_LIVE_SCORES_EVENTS_UPDATE_FILTER,
    payload: pickBy(payloadData, isArray)
  });
  
};

export const clearLiveScoresLeagueFilter = eventType =>(dispatch, getState) =>{
  dispatch({
    type: GET_LIVE_SCORES_CLEAR_FILTER,
    payload: eventType
  });

  dispatch(setLiveScoresFilterObject(
    eventType,
    getState().liveScores.liveScoresFilters[eventType]
  ));
};

export const clearLiveScoresFilter = eventType => (dispatch, getState) => {
  dispatch({
    type: GET_LIVE_SCORES_CLEAR_ALL_FILTER,
    payload: eventType
  });


  dispatch(setLiveScoresFilterObject(
    eventType,
    getState().liveScores.liveScoresFilters[eventType]
  ));
  
};

export const getLiveScoresOnlyLiveFilter = eventType => (dispatch, getState) => {
  dispatch(getLiveScoresEvents({
    eventType,
    filters: getState().liveScores.liveScoresFilters[eventType]
  }));
};


export const setLiveScoresFilterFromLocalStorage = () => dispatch => {
  loadStateFromIndexedDB('liveScoresFilterRequest', data => {
    dispatch({
      type: SET_LIVE_SCORES_FILTERS_FROM_LOCAL_STORAGE,
      payload: data
    });
  });
};

export const setLiveScoresActiveType = activeType => dispatch => {
  dispatch({
    type: LIVE_SCORES_ACTIVE_TYPE,
    activeType
  });
};
